import { SignIn } from '@clerk/clerk-react';
import { Logo } from '../components/Logo';

export function SignInPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-8 bg-bg p-6 text-fg">
      <Logo />
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" forceRedirectUrl="/" />
    </div>
  );
}
